/**
 * @generated SignedSource<<30110277276c10127e69cee195e1475d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddCityDialog_region$data = {
  readonly id: string;
  readonly " $fragmentType": "AddCityDialog_region";
};
export type AddCityDialog_region$key = {
  readonly " $data"?: AddCityDialog_region$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddCityDialog_region">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddCityDialog_region",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Region",
  "abstractKey": null
};

(node as any).hash = "8daaf1bb9d76f143a663ad80c27c4a5d";

export default node;
